import {batchFetch} from './batch-fetch';

const map = require('lodash/fp/map');

let batchQueue = [];
let timeoutId = null;
const mapUrlAndOptions = map(function(item) {
    return [item.url, item.options];
});

const service = {};

function makeRequests() {
    const requests = batchQueue;
    batchQueue = [];
    if (requests.length > 1) {
        batchFetch(service.config.batchUrl, mapUrlAndOptions(requests), {
            credentials: 'same-origin'
        })
            .then(function(resp) {
                if (resp.response.ok) {
                    resp.parsedResponses.forEach(function(response, i) {
                        requests[i].resolve(response);
                    });
                } else {
                    requests.forEach(function(req) {
                        req.reject(resp.response);
                    });
                }
            });
    } else if (requests.length === 1) {
        fetch(requests[0].url, requests[0].options)
            .then(function(response) {
                requests[0].resolve(response);
                return response;
            });
    }
}

function addToBatchQueue(request) {
    batchQueue.push(request);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(makeRequests, service.config.batchTimeout);
}

service.config = {
    batchTimeout: 100,
    batchUrl: '/$batch'
};

service.fetch = function fetchBatcher(url, options) {
    return new Promise(function promiseFn(resolve, reject) {
        addToBatchQueue({
            url,
            options,
            resolve,
            reject
        });
    });
};

export const BatcherService = service;
